class KhfFinder extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready) return;
    this.dataset.ready = 'true';
    this.form = this.querySelector('form');
    this.result = this.querySelector('[data-khf-result]');
    this.knownGallons = this.querySelector('[data-known-gallons]');
    this.calculator = this.querySelector('[data-calculator]');
    this.shape = this.querySelector('[name="shape"]');
    this.form.addEventListener('change', () => this.toggleFields());
    this.form.addEventListener('submit', (event) => this.submit(event));
    this.toggleFields();
    document.dispatchEvent(new CustomEvent('khf:configurator:open'));
  }

  toggleFields() {
    const known = this.form.querySelector('[name="gallons_known"]:checked')?.value;
    this.knownGallons.hidden = known !== 'yes';
    // Keep the calculator available as a second tool. The chosen option controls which value is used.
    this.calculator.hidden = false;
    const shape = this.shape?.value || 'rectangular';
    this.querySelectorAll('[data-shape-field]').forEach((field) => {
      field.hidden = !field.dataset.shapeField.split(' ').includes(shape);
    });
  }

  submit(event) {
    event.preventDefault();
    const data = new FormData(this.form);
    const poolType = data.get('pool_type');
    const known = data.get('gallons_known');
    let gallons = Number(data.get('gallons'));
    if (!poolType || !known) return this.showError('Select your pool type and whether you know the total gallons.');
    if (known === 'no') {
      const shape = data.get('shape');
      const shallow = Number(data.get('shallow_depth'));
      const deep = Number(data.get('deep_depth'));
      const averageDepth = (shallow + deep) / 2;
      const length = Number(data.get('length'));
      const width = Number(data.get('width'));
      const diameter = Number(data.get('diameter'));
      if (![shallow, deep, averageDepth].every(Number.isFinite) || shallow <= 0 || deep <= 0) return this.showError('Enter valid shallow and deep depths in feet.');
      if (shape === 'rectangular') {
        if (!Number.isFinite(length) || !Number.isFinite(width) || length <= 0 || width <= 0) return this.showError('Enter a valid pool length and width in feet.');
        gallons = length * width * averageDepth * 7.48052;
      }
      if (shape === 'circular') {
        if (!Number.isFinite(diameter) || diameter <= 0) return this.showError('Enter a valid pool diameter in feet.');
        gallons = Math.PI * Math.pow(diameter / 2, 2) * averageDepth * 7.48052;
      }
      if (shape === 'oval') {
        if (!Number.isFinite(length) || !Number.isFinite(width) || length <= 0 || width <= 0) return this.showError('Enter a valid pool length and width in feet.');
        gallons = Math.PI * (length / 2) * (width / 2) * averageDepth * 7.48052;
      }
    }
    if (!Number.isFinite(gallons) || gallons <= 0 || gallons > 1000000) return this.showError('Enter a realistic, positive pool volume.');
    const products = JSON.parse(this.dataset.products || '[]');
    const matches = products.filter((product) => (!product.poolType || product.poolType.includes(poolType) || poolType === 'not_sure') && gallons >= product.gallonMin && gallons <= product.gallonMax);
    if (!matches.length) {
      if (gallons > 30000) return this.showError(`Your estimated volume is ${Math.round(gallons).toLocaleString()} gallons. KHF currently offers product ranges through 30,000 gallons. Please contact support for assistance.`);
      return this.showError(`Your estimated volume is ${Math.round(gallons).toLocaleString()} gallons. No KHF product range is configured for this selection. Please contact support.`);
    }
    const productLinks = matches.sort((a, b) => a.title.localeCompare(b.title)).map((product) => `<a class="khf-button khf-button--blue" href="${this.escape(product.url)}">${this.escape(product.title)}</a>`).join('');
    const range = gallons <= 20000 ? '7.5K–20K gallons' : '20K–30K gallons';
    this.result.dataset.state = 'success';
    this.result.innerHTML = `<p class="khf-eyebrow">Estimated pool volume</p><h3>${Math.round(gallons).toLocaleString()} gallons</h3><p>Recommended KHF range: <strong>${range}</strong></p><div class="khf-finder__product-links">${productLinks}</div>`;
    document.documentElement.classList.add('khf-configurator-result-visible');
    document.dispatchEvent(new CustomEvent('khf:configurator:recommended', {
      detail: { gallons: Math.round(gallons), productCount: matches.length }
    }));
  }

  showError(message) { this.result.dataset.state = 'error'; this.result.textContent = message; }
  escape(value) { const el = document.createElement('span'); el.textContent = value || ''; return el.innerHTML; }
}
customElements.define('khf-product-finder', KhfFinder);

document.addEventListener('input', (event) => {
  if (!event.target.matches('[data-khf-faq-input]')) return;
  const scope = event.target.closest('[data-khf-faq-search]');
  const column = event.target.closest('.khf-help-center__column');
  if (!scope || !column) return;
  const query = event.target.value.trim().toLowerCase();
  column.querySelectorAll('[data-khf-faq-item]').forEach((item) => {
    item.hidden = query && !item.textContent.toLowerCase().includes(query);
  });
});
